import FormatConverter from '../geo/FormatConverter'

const SUPPORTED_FORMATS = [
  {
    name: 'Decimal Degrees (DD)',
    example: '38.889000, -77.035000',
    notes: 'Latitude first, comma-separated. Negative = S/W.',
  },
  {
    name: 'Degrees Minutes Seconds (DMS)',
    example: "38° 53' 20\" N, 77° 2' 6\" W",
    notes: 'With hemisphere. Seconds may be decimal.',
  },
  {
    name: 'MGRS',
    example: '18S UJ 23395 09512',
    notes: 'Spaces optional. Precision 1–5 (10km–1m). Polar zones supported.',
  },
  {
    name: 'UTM',
    example: '18N 323395 4307092',
    notes: 'Zone + N/S hemisphere, Easting, Northing.',
  },
]

export default function CoordinateToolsTab() {
  return (
    <div className="space-y-8">
      <div className="space-y-4">
        <h2 className="text-sm font-semibold text-muted-foreground uppercase tracking-wider">
          Coordinate Format Converter
        </h2>
        <FormatConverter />
      </div>

      <div className="space-y-4">
        <h2 className="text-sm font-semibold text-muted-foreground uppercase tracking-wider">
          Supported Formats
        </h2>
        <div className="divide-y divide-border rounded-lg border border-border overflow-hidden">
          {SUPPORTED_FORMATS.map((fmt) => (
            <div key={fmt.name} className="p-4 space-y-1">
              <div className="font-medium text-sm">{fmt.name}</div>
              <code className="text-xs font-mono text-blue-400">{fmt.example}</code>
              <p className="text-xs text-muted-foreground">{fmt.notes}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="space-y-4">
        <h2 className="text-sm font-semibold text-muted-foreground uppercase tracking-wider">
          MGRS Grid Zone Designator Reference
        </h2>
        <p className="text-xs text-muted-foreground">
          MGRS uses 60 longitude zones (1–60, 6° each) and 20 latitude bands (C–X, 8° each).
          Polar regions use UPS (A, B for south; Y, Z for north).
        </p>
        <div className="rounded-lg border border-border overflow-hidden text-xs font-mono">
          <table className="w-full">
            <thead className="bg-muted/50">
              <tr>
                <th className="px-3 py-2 text-left font-medium text-muted-foreground">Zone Range</th>
                <th className="px-3 py-2 text-left font-medium text-muted-foreground">Longitude</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border">
              {[
                ['1C–1X', '180°W – 174°W'], ['10C–10X', '138°W – 132°W'],
                ['18C–18X', '78°W – 72°W'], ['30C–30X', '6°W – 0°'],
                ['31C–31X', '0° – 6°E'], ['37C–37X', '36°E – 42°E'],
                ['54C–54X', '138°E – 144°E'], ['60C–60X', '174°E – 180°E'],
              ].map(([zone, cov]) => (
                <tr key={zone} className="hover:bg-muted/30">
                  <td className="px-3 py-1.5 text-blue-400">{zone}</td>
                  <td className="px-3 py-1.5 text-muted-foreground">{cov}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <p className="px-3 py-2 text-muted-foreground/60 text-xs">
            Representative entries — full table has 60 zones.
          </p>
        </div>
      </div>
    </div>
  )
}
